<template>
  <el-main style="padding: 30px 50px">
    <el-form
        ref="form"
        :rules="ruleValidate"
        :model="model"
        class="form"
        label-width="140px">
      <el-row>
        <el-col :sm="24" :md="12">
          <el-form-item label="旧条码" prop="oldSerialNumber">
            <el-input v-model="model.oldSerialNumber" placeholder="请输入就条码">
              <el-button slot="append" @click="getData"> 查询 </el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="物料类别">
            <el-radio-group v-model="model.materialType">
              <el-radio :label="1">贴片圆盘料</el-radio>
              <el-radio :label="2">非贴片圆盘料</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12">
          <el-form-item label="供应商名称" prop="supplier">
            <el-input v-model="model.supplier" disabled/>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12">
          <el-form-item label="物料号" prop="materialNo">
            <el-input v-model="model.materialNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12">
          <el-form-item label="物料描述" prop="materialName">
            <el-input v-model="model.materialName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12">
          <el-form-item label="本批总数" prop="allQuantity">
            <el-input v-model="model.allQuantity" placeholder="请输入本批总数"/>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12">
          <el-form-item label="最小包装标准数量" prop="packQuantity">
            <el-input v-model="model.packQuantity" placeholder="请输入最小包装标准数量"/>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12">
          <el-form-item label="生产日期" prop="productionDate">
            <el-date-picker
                v-model="model.productionDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12">
          <el-form-item label="失效日期" prop="expirationDate">
            <el-date-picker
                v-model="model.expirationDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item>
            <el-button v-if="model.materialType === 1" type="primary" @click="printHandle">打印标签</el-button>
            <el-button v-if="model.materialType === 2" type="primary" @click="reprintHandle(false)">打印标签</el-button>
            <el-button v-if="model.oldSerialNumber.length > 10" type="warning" @click="reprintHandle(true)">补打标签</el-button>
            <el-button @click="$refs.form.resetFields()">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-main>
</template>

<script>
  export default {
    data() {
      return {
        model: {
          oldSerialNumber: "",
          materialType: 1,
          supplier: "",
          materialNo: "",
          materialName: "",
          allQuantity: "",
          packQuantity: "",
          productionDate: "",
          expirationDate: "",
        },
        ruleValidate: {
          oldSerialNumber: [{ required: true, message: "旧条码不能为空", trigger: "blur" }],
          allQuantity: [
            { required: true, message: "本批总数不能为空", trigger: "blur" },
            { pattern: /^[1-9]\d*$/, message: "数字不合法，请输入大于0的整数！" },
          ],
          packQuantity: [
            { required: true, message: "最小包装标准数量不能为空", trigger: "blur" },
            { pattern: /^[1-9]\d*$/, message: "数字不合法，请输入大于0的整数！" },
          ],
          productionDate: [{ required: true, message: "生产日期不能为空", trigger: "change" }],
          expirationDate: [{ required: true, message: "失效日期不能为空", trigger: "change" }],
        },
      };
    },

    methods: {
      // 根据旧条码获取信息
      getData() {
        if (!this.model.oldSerialNumber) {
          this.$confirm("请输入旧条码", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$http.get("basic", `electricWarehouseLabelPrintingBatchs/getInfoBySerialNumber/${this.model.oldSerialNumber}`).then((res) => {
            if (res) {
              this.model.supplier = res.supplier;
              this.model.materialNo = res.materialNo;
              this.model.materialName = res.materialName;
            }
          });
        }
      },

      // 打印标签
      printHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            console.log(this.model.packQuantity);
            console.log(this.model.allQuantity);
            if (+this.model.packQuantity > 20000 || +this.model.allQuantity < +this.model.packQuantity) {
              this.$confirm("最小包装标准数量不能超过20000，且不能超过本批总数", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.$http
              .postForFile("basic", "electricWarehouseLabelPrintingBatchs/createUniqueCode", this.model)
              .then((res) => {
                let blob = new Blob([res.data], { type: "application/pdf" });
                let pdfUrl = window.URL.createObjectURL(blob);
                window.open(pdfUrl);
              })
              .catch(() => {
                this.$message.error("获取打印信息失败");
              });
          }
        });
      },

      // 补打标签
      reprintHandle(flag) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.model.packQuantity > 20000) {
              this.$confirm("最小包装标准数量不能超过20000", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            this.$http
              .postForFile("basic", `electricWarehouseLabelPrintingBatchs/printLabel2/${flag}`, this.model)
              .then((res) => {
                let blob = new Blob([res.data], { type: "application/pdf" });
                let pdfUrl = window.URL.createObjectURL(blob);
                window.open(pdfUrl);
              })
              .catch(() => {
                this.$message.error("获取打印信息失败");
              });
          }
        });
      },
    },
  };
</script>
